<template>
  <div>
    <el-dialog
      :title="type === 1 ? '编辑群组' : '新建群组'"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="dialogBeforeClose"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item
            prop="group_name"
            label="群组名称(必填)"
          >
            <el-input
              v-model="form.group_name"
              maxlength="15"
              show-word-limit
              style="width: 300px"
            />
          </el-form-item>
          <el-form-item
            label="群组编码(必填)"
            prop="group_code"
          >
            <el-input
              v-model="form.group_code"
              maxlength="16"
              show-word-limit
              style="width: 300px"
              :disabled="type === 1"
              @input="accountInput"
            />
            <div class="tips">
              只能输入英文、数字且唯一不可重复
            </div>
          </el-form-item>
          <el-form-item
            label="描述"
            prop="desc"
          >
            <el-input
              v-model="form.desc"
              style="width: 300px"
            />
          </el-form-item>

          <el-form-item
            v-if="!groupId"
            label="所属群组"
            prop="group_id"
          >
            <el-cascader
              ref="cascader"
              v-model="selectGroupId"
              :options="options"
              :props="{ checkStrictly: true, value: 'id', label: 'group_name' }"
              clearable
              style="width: 300px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogBeforeClose">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="submitGroup"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SpEditGroup',
  model: {
    prop: 'dialogVisible',
    event: 'changeEditGroupVisible'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0 //0是创建新群组，1更新群组
    }
  },
  data () {
    return {
      form: {
        group_name: '',
        group_code: '',
        desc: ''
      },
      options: [],
      selectGroupId: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.form = {
          group_name: '',
          group_code: '',
          desc: ''
        }
        this.selectGroupId = null
      }
      if (val && !this.groupId) {
        this.getList()
      } else if (val && this.groupId && this.type === 1) {
        this.initInfo(this.groupId)
      }
    }
  },
  mounted () {},
  methods: {
    // 获取群组列表
    async getList () {
      const data = await this.$api.organization.getGroupsList()
      if (data) {
        this.options = data.list
      }
    },
    async initInfo (id) {
      const data = await this.$api.organization.getGroupsInfo(id)
      if (data) {
        this.form = data
      }
    },
    dialogBeforeClose () {
      this.$emit('changeEditGroupVisible', false)
    },
    async submitGroup () {
      let params = this.form
      const { group_name, group_code } = params
      if (group_name === '' || group_name === undefined || group_name === null) {
        return this.$message.error('请输入群组名称')
      }
      if (group_code === '' || group_code === undefined || group_code === null) {
        return this.$message.error('请输入群组编码')
      }

      if (this.selectGroupId) {
        let groupId = this.$refs.cascader.getCheckedNodes(true)
        params.group_id =
          groupId && groupId.length > 0 && Number(groupId.map((v) => v.value).join(''))
      } else {
        params.group_id = this.groupId
      }

      if (this.type === 1) {
        const data = await this.$api.organization.updateGroups(this.groupId, params)
        if (data) {
          this.$message.success('编辑成功')
          this.$emit('submitGroup')
        } else {
          this.$message.error('编辑失败')
        }
      } else {
        const data = await this.$api.organization.createGroups(params)
        if (data) {
          this.$message.success('创建成功')
          this.$emit('submitGroup')
        } else {
          this.$message.error('创建失败')
        }
      }
    },

    accountInput (val) {
      //账号的实时输入
      let codeReg = new RegExp('[A-Za-z0-9]+'), //正则 英文+数字；
        len = val.length,
        str = ''
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i]
        }
      }
      this.form.group_code = str
    }
  }
}
</script>

<style lang="scss" scoped>
.label-list {
  display: flex;
  align-items: center;
}
.label-input {
  width: 300px;
}
.btn-box {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
}
.add-label {
  display: flex;
  align-items: center;
  .btn-box {
    border-color: #409eff;
  }
}
.tips {
  font-size: 12px;
  color: #bfbfbf;
}
</style>
